document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".library-tabs .tab");
  const contentContainer = document.getElementById("dynamic-content-container");

  tabs.forEach((tab) => {
    tab.addEventListener("click", async () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const selectedTab = tab.dataset.tab;

      if (selectedTab === "ingredients") {
        try {
          const response = await fetch("/products.json");
          if (!response.ok) throw new Error("Failed to fetch products");

          const data = await response.json();
          console.log("Fetched Products:", data);

          // Extract products with the 'ingredient' metafields
          const ingredients = data.products.filter(
            (product) =>
              product.metafields &&
              product.metafields.ingredient &&
              product.metafields.ingredient.name
          );

          console.log("Filtered Ingredients:", ingredients);

          if (ingredients.length > 0) {
            contentContainer.innerHTML = ingredients
              .map((product) => {
                const metafields = product.metafields.ingredient;
                return `
                  <div class="ingredient-item">
                    <h2>${metafields.name || "Unnamed Ingredient"}</h2>
                    <p>${
                      metafields.description || "No description available."
                    }</p>
                    <p><strong>Benefits:</strong> ${
                      metafields.benefits || "No benefits listed."
                    }</p>
                    ${
                      metafields.image_url
                        ? `<img src="${metafields.image_url}" alt="${metafields.name}" />`
                        : ""
                    }
                  </div>`;
              })
              .join("");
          } else {
            contentContainer.innerHTML = "<p>No ingredients found.</p>";
          }
        } catch (error) {
          console.error("Error fetching ingredients:", error);
          contentContainer.innerHTML =
            "<p>Error loading ingredients. Please try again later.</p>";
        }
      } else {
        const tabContent = {
          science: "<h3>Science</h3><p>Coming soon!</p>",
          remedies: "<h3>Ancient Remedies</h3><p>Coming soon!</p>",
          recipes: "<h3>Recipes & Applications</h3><p>Coming soon!</p>",
        };
        contentContainer.innerHTML =
          tabContent[selectedTab] || "<p>No content available.</p>";
      }
    });
  });
});
